import { HttpErrorResponse } from '@angular/common/http';

/**
 * Enriched requests poll subscrib.ly. A server, gateway, or network failure
 * on those requests means we should load Doddly data without that poll.
 * Auth failures are never treated as a subscrib.ly outage.
 */
export function shouldFallbackFromSubscribly(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) {
    return false;
  }

  if (error.status === 401 || error.status === 403) {
    return false;
  }

  if (mentionsSubscribly(error)) {
    return true;
  }

  return error.status === 0 || error.status >= 500;
}

function mentionsSubscribly(error: HttpErrorResponse): boolean {
  const parts = [error.message, error.statusText];
  const body = error.error;

  if (typeof body === 'string') {
    parts.push(body);
  } else if (body && typeof body === 'object') {
    parts.push(JSON.stringify(body));
  }

  return /subscrib\.?ly/i.test(parts.filter(Boolean).join(' '));
}
